import { useEffect, useRef } from "react";
import { CardBody } from "reactstrap";

import MessageBubble from "./MessageBubble";
import { ChatMessage } from "../types/ChatMessage";

interface Props {
    messages: ChatMessage[];
    onReply: (message: ChatMessage) => void;
    reactionRefresh: number;

    onEdit: (
        messageId: string,
        message: string
    ) => Promise<void>;

    onDelete: (
        messageId: string
    ) => Promise<void>;
}

const MessageList = ({
    messages,
    onReply,
    reactionRefresh,
    onEdit,
    onDelete
}: Props) => {

    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        requestAnimationFrame(() => {
            if (containerRef.current) {
                containerRef.current.scrollTop =
                    containerRef.current.scrollHeight;
            }
        });
    }, [messages]);

    return (
        <CardBody
             innerRef={containerRef}
            style={{
                height: "60vh",
                overflowY: "auto"
            }}
        >
            {messages.map(message => (
                <MessageBubble
                    key={message.chatMessageId}
                    message={message}
                    reactionRefresh={reactionRefresh}
                    onReply={onReply}
                    onEdit={onEdit}
                    onDelete={onDelete}
                />
            ))}
        </CardBody>
    );
};

export default MessageList;